import React, { useState } from 'react';
import { ScanBarcode, MinusCircle, PackageSearch, ClipboardCheck, PlusCircle, ArrowLeftRight, Send } from 'lucide-react';
import BarcodeScanner from '../../components/inventory/BarcodeScanner';

const MODES = [
  { key: 'lookup',          label: 'Lookup',          icon: PackageSearch,  color: 'text-[#A3A3A3]',  desc: 'Check where a part is stocked and how many.' },
  { key: 'van_count',       label: 'Van Count',       icon: ClipboardCheck, color: 'text-amber-400',  desc: 'Count and correct the quantity on your van.' },
  { key: 'restock_van',     label: 'Restock Van',     icon: PlusCircle,     color: 'text-green-400',  desc: 'Receive stock onto your van.' },
  { key: 'transfer',        label: 'Transfer',        icon: ArrowLeftRight, color: 'text-blue-400',   desc: 'Move stock between locations.' },
  { key: 'request_restock', label: 'Request Restock', icon: Send,           color: 'text-[#D4AF37]',  desc: 'Ask the shop to restock a part.' },
];

const InventoryScanner = () => {
  const [mode, setMode] = useState(null);

  return (
    <div data-testid="employee-inventory-scanner" className="space-y-6">
      <div>
        <h2 className="font-['Outfit'] text-3xl font-bold text-white mb-1 flex items-center gap-3">
          <ScanBarcode className="w-7 h-7 text-[#D4AF37]" /> Inventory Scanner
        </h2>
        <p className="text-[#A3A3A3] text-sm">Scan a part with your camera or a Bluetooth scanner. Pick what you want to do.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {MODES.map((m) => {
          const Icon = m.icon;
          return (
            <button key={m.key} data-testid={`scan-mode-${m.key}`} onClick={() => setMode(m.key)}
              className="text-left rounded-md border border-[#262626] bg-[#141414] hover:bg-[#1c1c1c] hover:border-[#D4AF37]/40 p-4 transition-colors">
              <Icon className={`w-6 h-6 ${m.color} mb-2`} />
              <p className="text-white font-semibold">{m.label}</p>
              <p className="text-[#A3A3A3] text-xs mt-1 leading-snug">{m.desc}</p>
            </button>
          );
        })}
      </div>

      <BarcodeScanner open={!!mode} mode={mode || 'scan'} onClose={() => setMode(null)} />
    </div>
  );
};

export default InventoryScanner;
